import { common, crypto, InvalidFormatError, InvocationTransactionModel, IOHelper, JSONHelper, } from '@neo-one/client-common';
import { VerifyError } from '../errors';
import { utils } from '../utils';
import { TransactionBase } from './TransactionBase';
import { TransactionType } from './TransactionType';
const MAX_SCRIPT_SIZE = 65536;
export class InvocationTransaction extends TransactionBase(InvocationTransactionModel) {
    constructor() {
        super(...arguments);
        this.sizeExclusive = utils.lazy(() => IOHelper.sizeOfUInt8 + IOHelper.sizeOfVarBytesLE(this.script));
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        const { type, version } = super.deserializeTransactionBaseStartWireBase(options);
        if (type !== TransactionType.Invocation) {
            throw new InvalidFormatError(`Expected transaction type to be ${TransactionType.Invocation}. Received: ${type}`);
        }
        const script = reader.readVarBytesLE(MAX_SCRIPT_SIZE);
        if (script.length === 0) {
            throw new InvalidFormatError('Expected invocation script length to not be 0');
        }
        let gas = utils.ZERO;
        if (version >= 1) {
            gas = reader.readFixed8();
        }
        const { attributes, inputs, outputs, scripts } = super.deserializeTransactionBaseEndWireBase(options);
        return new this({
            version,
            attributes,
            inputs,
            outputs,
            scripts,
            script,
            gas,
        });
    }
    async serializeJSON(context) {
        const transactionBaseJSON = await super.serializeTransactionBaseJSON(context);
        const data = await context.tryGetInvocationData(this);
        let invocationDataJSON;
        if (data !== undefined) {
            const { asset, contracts, deletedContractHashes, migratedContractHashes, voteUpdates, actions, result, storageChanges, } = data;
            invocationDataJSON = {
                result: result.serializeJSON(context),
                asset: asset === undefined ? undefined : asset.serializeJSON(context),
                contracts: contracts.map((contract) => contract.serializeJSON(context)),
                deletedContractHashes: deletedContractHashes.map((hash) => common.uInt160ToString(hash)),
                migratedContractHashes: migratedContractHashes.map(([from, to]) => [common.uInt160ToString(from), common.uInt160ToString(to)]),
                voteUpdates: voteUpdates.map(([address, votes]) => [
                    crypto.scriptHashToAddress({
                        addressVersion: context.addressVersion,
                        scriptHash: address,
                    }),
                    votes.map((vote) => common.ecPointToString(vote)),
                ]),
                actions: actions.map((action) => action.serializeJSON(context)),
                storageChanges: storageChanges.map((storageChange) => storageChange.serializeJSON(context)),
            };
        }
        return {
            ...transactionBaseJSON,
            type: 'InvocationTransaction',
            script: JSONHelper.writeBuffer(this.script),
            gas: JSONHelper.writeFixed8(this.gas),
            invocationData: invocationDataJSON,
        };
    }
    getSystemFee(_context) {
        return this.gas;
    }
    async verify(options) {
        if (!this.gas.mod(utils.ONE_HUNDRED_MILLION).eq(utils.ZERO)) {
            throw new VerifyError('Invalid GAS amount');
        }
        return super.verify(options);
    }
}

//# sourceMappingURL=InvocationTransaction.js.map
